import { Injectable } from '@angular/core';
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ISystem, IAvbobConnectData, IAvatar } from '../interface';
import { UserService, UserInfo } from './user.service';
import { MessageService } from './message.service';
import * as moment from 'moment';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import * as signalR from '@microsoft/signalr';
import { OAuthService } from 'angular-oauth2-oidc';
import { authConfig } from '../auth.config';
import { Session } from 'inspector';


@Injectable({ providedIn: 'root' })
export class ApplicationService {

  public currentSystem: ISystem;
  public applicationName: string = "ONE AVBOB Connect";
  public profileText: string;
  public pageTitle: string;
  public year: number;
  public shell = false;
  public showBanner = false;
  public appSettings;
  public apiServiceUrl: string;
  public policyServiceUrl: string;
  public onlineSalesApi: string;
  public documentServiceUrl: string;
  public intranetUrl: string;
  public appLinxUrl = '';
  public appLinxUrlLegacy = '';
  public appRepositoryUrl: string;
  public selfServiceAVAUrl: string;
  public settingsLoaded = false;
  public testSystem: ISystem;
  public AvbobConnect: IAvbobConnectData;
  public environment = "";
  public currentTime = new Date();
  public hasChromeExtension = false;
  public rootFolder = null;
  public galleryTitle = "";
  public serverData: any;
  public Avatars: IAvatar[] = [];

  public ApplicationMode: ApplicationMode;
  public isKiosk = false;
  public isInMaintenance = false;

  public loaded = false;
  public applicationMode: ApplicationMode;

  public isBusy = false;

  idleState = 0;
  idleWarning = "";
  timedOut = false;
  lastPing?: Date = null;

  genesysChatScriptTag: HTMLScriptElement = null;

  public idpAuthority = "";
  public idpEnableKeycloakIdp = "false";
  public idpClientId = "";


  constructor(
    private oauthService: OAuthService,
    private router: Router,
    public userService: UserService,
    public messageService: MessageService,
    private http: HttpClient,
    public idle: Idle,
    public keepalive: Keepalive) {

    let state = signalR.HubConnectionState.Connected;

    sessionStorage.removeItem("enableCallMe");

    this.apiServiceUrl = this.isLocal ? "http://localhost:63699/api/" : "/api/";
    this.messageService.log.subscribe(item => {
      this.logError(item);
    });

    this.initialise();

    if (this.isLocal && !this.testSystem) {
      this.testSystem = {
        Code: "TEST",
        Name: "appname",
        Tag: null,
        Url: "ng:appname",
        UserRoles: [],
        UserGroups: []
      }

    }

  }

  public initialise() {
    sessionStorage.removeItem("applyonline");
    sessionStorage.removeItem("enableCallMe");
    sessionStorage.removeItem("complaint");
    //sessionStorage.removeItem("inQubaContactId");
    sessionStorage.removeItem("idpReset");
    sessionStorage.removeItem("idpKeycloak");
    sessionStorage.removeItem("idpUsername");
    var urlParts = window.location.href.split("?");
    if (urlParts.length > 1) {
      localStorage.setItem("parms", urlParts[1]);
    }
    if (window.location.href.indexOf('apply') > -1) {
      sessionStorage.setItem("applyonline", "true");
    }
    let isForComplaint: boolean = false;
    if (window.location.href.indexOf('/complaint') > -1) {
      isForComplaint = true;
    }
    this.Route(this.router);
    this.year = (new Date()).getFullYear();
    let service = this;
    let avbobJWT = sessionStorage.getItem("avbobJWT");
    if (avbobJWT) {
      sessionStorage.removeItem("avbobJWT");
    }
    this.http.get<any>(this.apiServiceUrl + 'Application/Settings')
      .toPromise().then(response => {
        service.http.get<any>(service.apiServiceUrl + 'Application/ServerData')
          .toPromise().then(_response => {
            service.serverData = _response;
            service.applicationMode = service.serverData.ApplicationMode;
            service.isKiosk = service.serverData.IsKiosk;
            service.isInMaintenance = service.serverData.IsInMaintenance;
            service.idpAuthority = service.serverData.IdpAuthority;
            service.idpClientId = service.serverData.IdpClientId;
            service.idpEnableKeycloakIdp = service.serverData.IdpEnableKeycloakIdp;
            service.messageService.applicationMode = service.applicationMode;
            service.loadSettings(response);
            if (service.applicationMode && service.applicationMode == ApplicationMode.SelfService) {
              if (avbobJWT) {
                if (!service.enableKeycloakIdp) {
                  sessionStorage.setItem("avbobJWT", avbobJWT);
                }
              }
            }
            else {
              if (avbobJWT) {
                sessionStorage.setItem("avbobJWT", avbobJWT);
              }
            }
            service.loadUserProfile();
            service.resizeMain();
            service.loaded = true;
            service.startIdle();
            if (service.isInMaintenance && (service.applicationMode == ApplicationMode.Central || service.applicationMode == ApplicationMode.Broker || service.applicationMode == ApplicationMode.Business)) {
              this.router.navigate(['/account/maintenance']);
              return;
            }
            if (service.applicationMode && service.applicationMode == ApplicationMode.SelfService) {
              const urlParams = new URLSearchParams(urlParts[1]);
              var leadId = urlParams.get('uid');
              var prdId = urlParams.get('prd');
              if (leadId && prdId) {
                if (!leadId.toUpperCase().startsWith("NR")) {
                  leadId = "NR" + leadId;
                }
                localStorage.setItem("leadId", leadId);
                localStorage.setItem("prdid", prdId);
              }
              var inQubaContactId = urlParams.get('ContactId');
              if (inQubaContactId && inQubaContactId.trim().length > 0) {
                var inQuba_utm_source = urlParams.get('utm_source');
                if (inQuba_utm_source && inQuba_utm_source.trim().length > 0 && inQuba_utm_source.trim().toLowerCase() === 'inquba') {
                  sessionStorage.setItem("inQubaContactId", inQubaContactId.trim());
                }
              }
              if (isForComplaint) {
                sessionStorage.setItem("complaint", "true");
              }
              var idpReset = urlParams.get('idpReset');
              let idpUsername = urlParams.get('idpUsername');
              var idpKeycloak = urlParams.get('idpKeycloak');
              if (idpReset && idpReset.trim().length > 0 && idpReset.trim() === 'true') {
                if (idpUsername.trim().length > 0) {
                  sessionStorage.setItem('idpUsername', idpUsername.trim());
                }
                sessionStorage.setItem('idpKeycloak', idpKeycloak.trim());
                sessionStorage.setItem("idpReset", idpReset.trim());
              }
            }
            if (service.applicationMode && service.applicationMode == ApplicationMode.SelfService) {
              if (service.enableKeycloakIdp) {
                authConfig.issuer = service.idpAuthority;
                authConfig.clientId = service.idpClientId;
                authConfig.redirectUri = window.location.origin;
                service.oauthService.configure(authConfig);
                service.oauthService.setupAutomaticSilentRefresh();
                //component.oauthService.tokenValidationHandler = new JwksValidationHandler();
                //service.oauthService.loadDiscoveryDocumentAndTryLogin();
                service.oauthService.loadDiscoveryDocument();
              }
            }
          });
      });
  }

  public Avatar(username: string): IAvatar {

    if (username) {
      username = username.toUpperCase();
      let avatar = this.Avatars.find(i => i.Username == username);
      if (avatar) {
        return avatar;
      }
      else {
        avatar = {
          Fullname: username,
          Username: username,
          Photo: "https://intranet.avbob.co.za:447/CoreApi/user/photo?username=" + username
        };
        this.Avatars.push(avatar);
        this.http.get<IAvatar>(this.apiServiceUrl + 'User/Avatar?username=' + username)
          .toPromise().then(response => {
            if (response) {
              this.Avatars.splice(this.Avatars.indexOf(avatar), 1);
              this.Avatars.push(response);
            }
          });
      }
    }
    username = username || "anonymous";
    return {
      Fullname: username,
      Username: username,
      Photo: "https://intranet.avbob.co.za:447/CoreApi/user/photo?username=" + username
    }

  }

  get checkOtp(): string {
    if ((this.applicationMode == ApplicationMode.Business) && this.router.url.toLowerCase().indexOf("account") < 0 && !this.isLocal) {
      if (!sessionStorage.getItem("localOTP")) {
        this.login();
      }
    }
    return "";
  }

  updateClientLead() {
    let campaign = "";
    let tracking = localStorage.getItem("tracking");
    if (tracking) {
      const urlParams = new URLSearchParams(tracking);
      campaign = urlParams.get('source').toUpperCase()
    }
    let leadData = {
      Campaign: campaign,
      LeadId: localStorage.getItem("leadId"),
      StepId: 51,
      Step: "Call Back Requested"
    };
    this.http.post<any>(this.onlineSalesApi + 'policy/UpdateClientLead', leadData)
      .toPromise().then(response => { });
  }

  repLoginStat() {

    let service = this;
    if (this.applicationMode == ApplicationMode.Business && !sessionStorage.getItem("loginId")) {

      var data = {
        Id: "A31D90B6-E01F-4034-926B-57702D476152", // dummy value to bypass modelstate
        Date: moment().toDate(),
        AreaManager: this.userService.userInfo.RepInfo.AmNr,
        DistrictManager: this.userService.userInfo.RepInfo.DmBcNr,
        Representative: this.userService.userInfo.Username,
        Region: this.userService.userInfo.RepInfo.mregion.toString()
      }

      this.http.post<any>(this.onlineSalesApi + '/Reporting/SaveRepLogin', data)
        .toPromise().then(response => {
          if (response) {
            sessionStorage.setItem("loginId", response);
            this.updateDuration(service);
          }
        });
    }

  }

  logError(error: any) {
    try {
      if (window.navigator.onLine) {
        this.http.post<any>(this.apiServiceUrl + 'Application/Error', error)
          .toPromise().then(response => {

          });
      }
    }
    catch { }

  }

  loadApp() {

    $("#loginPanel").remove();

    if (this.isLocal) {

      var url = 'http://localhost:4201/';
      this.http.get(url, { responseType: 'text' })
        .toPromise()
        .then(response => {
          var applicationScript = response.split('"').find((str) => str.indexOf('main') > -1 && str.indexOf('.js') > -1);
          if (applicationScript) {
            this.loadJS(url + applicationScript, this);
          }
          else {
            this.showError(`Application script could not be loaded. Are you running the application at ${url}?`);
            this.router.navigate(['/']);
          }
        });
    }
    else {
      var date = moment().format("YYYYMMDD");

      if (this.applicationMode == ApplicationMode.SelfService) {
        var scriptUrl = `${this.appRepositoryUrl}public/?application=selfservice&d=` + date;
        let download = this.http.get(scriptUrl, { responseType: 'blob' });
        download.subscribe(data => this.addToDOM(data, "Self Service", this));
      }
      else {
        let systemCode = "OACC";
        let appName = "Connect Central";

        if (this.applicationMode == ApplicationMode.Business) {
          systemCode = "OACB";
          appName = "Connect Business";
        }
        else if (this.applicationMode == ApplicationMode.Broker) {
          systemCode = "OACDB";
          appName = "Digital Broker";
        }

        var scriptUrl = `${this.appRepositoryUrl}application/${systemCode}?d=` + date;
        let download = this.http.get(scriptUrl, { responseType: 'blob' });
        download.subscribe(data => this.addToDOM(data, appName, this));
      }

    }

  }

  addToDOM(data: any, appName: string, application: any) {
    var blob = new Blob([data], { type: 'application/javascript' });
    var url = window.URL.createObjectURL(blob);
    this.loadJS(url, application);
  }

  public get currentUser(): string {
    if (this.userService.userInfo) {
      return this.userService.userInfo.Username;
    }
    return "";
  }

  get userInfo(): UserInfo {
    return this.userService.userInfo;
  }

  loadUserProfile() {
    if (this.applicationMode == ApplicationMode.SelfService) {
      this.loadApp();
    }
    else {
      if (!sessionStorage.getItem("avbobJWT")) {
        this.login();
      }
      else {
        this.http.get<any>(this.apiServiceUrl + '/User/Load')
          .toPromise().then(response => {

            if (this.applicationMode == ApplicationMode.Business && isNaN(response.Username)) {
              this.login();
              return;
            }

            this.userService.userInfo = response as UserInfo;
            this.repLoginStat();
            this.refreshToken(this);
            this.router.navigate(['/']);
            this.messageService.refresh = true;
            this.loadApp();
          })
          .catch(err => {
            sessionStorage.removeItem("avbobJWT");
            sessionStorage.removeItem("loginId");
            this.login();
          });
      }
    }
  }

  public loadSettings(response) {

    this.appSettings = response;
    this.intranetUrl = response["Legacy.IntranetUrl"];
    this.appRepositoryUrl = response["Connect.AppRepositoryUrl"];
    this.onlineSalesApi = response["API.OnlineSalesUrl"];
    this.selfServiceAVAUrl = response["SelfService.AVAUrl"];
    this.environment = response["Environment"];
    this.messageService.showErrorDetail = response["ShowErrorDetail"];
    localStorage.setItem("avb_genesyschat", response["SelfService.LiveChatUrl"]);

    if (this.applicationMode == ApplicationMode.Business) {
      this.messageService.errorMessage = " - " + response["ErrorMessageBusiness"];
    }
    else if (this.applicationMode == ApplicationMode.Central) {
      this.messageService.errorMessage = " - " + response["ErrorMessage"];
    }

    this.settingsLoaded = true;

    var isMLM = window.location.href.toUpperCase().indexOf('MLM') > -1;
    if (!isMLM && response["SelfService.EnableChat"] == "true") {
      // this.loadGenesysChat();
    }

  }

  public login() {
    sessionStorage.removeItem("localOTP");
    sessionStorage.removeItem("avbobJWT");
    sessionStorage.removeItem("loginId");
    this.router.navigate(['/account/login']);
  }

  logout() {
    sessionStorage.removeItem("localOTP");
    sessionStorage.removeItem("avbobJWT");
    sessionStorage.removeItem("loginId");
    sessionStorage.removeItem("inQubaContactId");
    sessionStorage.removeItem("idpTokenReceived");
    window.location.reload(true);
  }

  startIdle() {

    // idleState: 0 = not started, 1 = active, 2 = warning, 3 = dead

    let idleTimeout = this.isKiosk ? 3 : 15;
    if (this.isLocal) {
      idleTimeout = 180;
    }
    this.idle.setIdle(idleTimeout * 60); // the amount of time the screen must be idle before warning counter starts
    this.idle.setTimeout(60); //the amount of time to show a warning before session times out
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    this.idle.onIdleEnd.subscribe(() => this.resetIdle());

    this.idle.onTimeout.subscribe(() => {
      this.idleState = 3; // session is dead
      this.timedOut = true;
      this.logout();
    });

    this.idle.onIdleStart.subscribe(() => {
      this.idleState = 2; // start idle warning state
    });

    this.idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleWarning = 'Your session will time out in ' + countdown + ' seconds!'
    });

    // sets the ping interval to 15 seconds
    this.keepalive.interval(15);

    this.keepalive.onPing.subscribe(() => this.lastPing = new Date());

    this.resetIdle();
  }

  resetIdle() {
    this.idle.watch();
    this.idleState = 1;
    this.idleWarning = "";
    this.timedOut = false;
  }

  tokenCounter = 0;
  refreshToken(service) {

    let refreshToken = sessionStorage.getItem("avbobJWTRefresh");
    if (service.userService.userInfo && refreshToken) {
      this.http.post<any>(service.apiServiceUrl + '/User/RefreshToken', { refresh_token: refreshToken })
        .toPromise()
        .then(response => {
          if (response.success) {
            sessionStorage.setItem("avbobJWT", response.access_token);
            sessionStorage.setItem("avbobJWTRefresh", response.refresh_token);
            localStorage.setItem("integrationJWT", response.access_token);
            service.tokenCounter = 0;
          }
        })
        .catch(() => {
          if (service.tokenCounter < 2) {
            service.tokenCounter += 1;
          }
          else {
            alert("Your access token could not be updated after 3 attempts and your session has expired");
            window.location.reload();
          }
        });

    }

    window.setTimeout(() => {
      service.refreshToken(service);
    }, 5 * 60 * 1000);

  }

  updateDuration(service) {

    try {
      this.http.get<any>(service.onlineSalesApi + '/Reporting/UpdateRepLogin?id=' + sessionStorage.getItem("loginId"))
        .toPromise().then(response => {

        });
    }
    catch (ex) { }
    window.setTimeout(() => {
      service.updateDuration(service);
    }, 1 * 60 * 1000);
  }


  loadGenesysChat() {
    if (this.applicationMode == ApplicationMode.SelfService) {
      if (!this.genesysChatScriptTag) {
        this.genesysChatScriptTag = document.createElement('script');
        this.genesysChatScriptTag.src = this.apiServiceUrl.replace("/api/", "") + "/scripts/genesys-chat.js";
        document.body.appendChild(this.genesysChatScriptTag);
      }
      else {
        const event = new Event("webChatOpen");
        window.dispatchEvent(event);
      }
      this.genesysChatScriptTag.onload = () => {
      };
      this.genesysChatScriptTag.onerror = () => {
      };
    }
  }

  loadJS(url, application) {

    application.shell = true;
    var scriptTag = document.createElement('script');
    scriptTag.src = url;
    scriptTag.onload = function () {

      var shell = "connect_central";
      if (application.applicationMode == 2) {
        shell = "selfservice";
      }
      else if (application.applicationMode == 3) {
        shell = "connect_business";
      }
      else if (application.applicationMode == 4) {
        shell = "connect_broker";
      }
      var require = eval("__webpack_require__");
      var app = require("./" + shell + "/main.ts");
    };
    document.body.appendChild(scriptTag);
  }

  get today(): Date {
    return new Date();
  }


  url = "";

  get isHomePage(): boolean {
    if (this.url != window.location.href) {
      this.url = window.location.href;
      this.resizeMain();
    }
    return (this.url.indexOf("/connect/home") > -1 || this.url.indexOf("/account/") > -1);
  }

  get isLocal(): boolean {
    return window.location.href.indexOf('localhost') > -1;
  }

  public toggleBanner(expand: boolean = null) {
    if (expand !== null) {
      this.showBanner = expand;
    }
    else {
      this.showBanner = !this.showBanner;
    }
    this.resizeMain();
  }

  public resizeMain() {
    let resize = window["resize"] as any;
    resize();
    this.logRoute();
  }

  currentUrl = "";
  public logRoute() {

    //var url = window.location.href.split('?')[0];
    //if (this.currentUrl != url) {
    //  this.currentUrl = url;
    //  var server = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
    //  this.createApplicationLog("Route", url.replace(server, ''));
    //}
  }

  public createApplicationLog(logType: string, logIndex: string, data: any = null, branchCode: number = 500, branchName: string = "HEAD OFFICE") {
    var model = {
      ConnectionId: this.serverData.ConnectionId,
      LogType: logType,
      LogIndex: logIndex,
      Username: this.userInfo ? this.userInfo.Username : 'guest',
      DisplayName: this.userInfo ? this.userInfo.DisplayName : 'Guest',
      Data: data ? JSON.stringify(data) : '',
      BranchCode: branchCode,
      BranchName: branchName
    }
    let continueWithCreateApplicationLog: boolean = true;
    if (this.enableKeycloakIdp) {
      if (this.applicationMode === ApplicationMode.SelfService) {
        if (logType === 'MicroUI') {
          continueWithCreateApplicationLog = false;
        }
      }
    }
    if (continueWithCreateApplicationLog) {
      const httpOptions = {
        headers: new HttpHeaders({ 'apiKey': this.apiKey })
      };
      this.http.post<any>(this.apiServiceUrl + '/Application/Log', model, httpOptions).toPromise();
    }
  }

  public Route(router: Router) {
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {

      }
      else if (event instanceof NavigationEnd) {
        this.resizeMain();
      }
    });
    return true;
  }

  public showError(message: string) {
    let connectionMessage = "";
    if (!this.isLocal && !window.navigator.onLine) {
      connectionMessage = "You are Offline! ";
    }
    this.messageService.showError(connectionMessage + message);
  }

  public validate(fieldName: string): string {
    if (this.AvbobConnect) {
      return this.AvbobConnect.Validator.Validate(fieldName);
    }
    return null;
  }

  public addValidation(fieldName: string, message: string) {
    if (this.AvbobConnect) {
      this.AvbobConnect.Validator.Add({ FieldName: fieldName, Message: message });
    }
  }

  public clearValidations(fieldName: string) {
    if (this.AvbobConnect) {
      this.AvbobConnect.Validator.Clear();
    }
  }

  public showSuccess(message: string) {
    this.messageService.showSuccess(message);
  }

  public get enableKeycloakIdp(): boolean {
    return this.idpEnableKeycloakIdp == "true";
  }

  get apiKey(): any {
    return '02238F41-0305-4870-A810-EBA8895BA33E';
  }

  public get connectVersion(): string {
    return '25.08.28.1';
  }

}

export enum ApplicationMode {
  Central = 1,
  SelfService,
  Business,
  Broker
}


